import React from 'react';

import { Alert, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const IsValidGroup = ({
    isValid,
    item,
    maxCols,
    maxRows,
    minCols,
    minRows,
}) => {
    const { t } = useTranslation();
    return (
        <>
            {!isValid && (
                <Alert severity="error">
                    {!item.valid.dimension && (
                        <>
                            <Typography>
                                {t('Invalid group dimensions')}
                            </Typography>
                            <Typography>
                                {t(
                                    'Min cols {{minCols}}, Max cols {{maxCols}}, Min rows {{minRows}}, Max rows {{maxRows}}',
                                    {
                                        maxCols,
                                        maxRows,
                                        minCols,
                                        minRows,
                                    },
                                )}
                            </Typography>
                        </>
                    )}
                </Alert>
            )}
        </>
    );
};

IsValidGroup.propTypes = {
    isValid: PropTypes.bool,
    item: PropTypes.object,
    maxCols: PropTypes.number,
    maxRows: PropTypes.number,
    minCols: PropTypes.number,
    minRows: PropTypes.number,
};

export default IsValidGroup;
